import React from "react";
import Flexbox from "../../../components/flexbox";
import style from "./newTableCells.module.scss";

const EmptyCell = () => {
  return <Flexbox>{({ Column }) => <Column className={style.cell} />}</Flexbox>;
};

export default EmptyCell;
